import styled from '@emotion/styled';

export const Main = styled.div`
  position: relative;
  padding: 16px;
  padding-top: 39px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  // min-height: 100svh;
  height: 100%;
  flex-grow: 1;
  overflow: auto;
`;

export const Notification = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px;
  padding: 16px;
  border-radius: 12px;
  border-width: 2px;
  border-color: rgba(94, 132, 237, 0.6);
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.25);

  outline: 2px rgba(94, 132, 237, 0.6) solid;
  outline-offset: -1px;
`;

export const NotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Pill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 9999px;
  background: rgba(94, 132, 237, 0.25);
  width: fit-content;
`;

export const PillDot = styled.div`
  width: 5px;
  height: 5px;
  background: #5e84ed;
  border-radius: 999px;
`;

export const PillText = styled.span`
  color: #b7bdcb;
  font-size: 12px;
  font-family: Inter;
  font-weight: 500;
  line-height: 120%;
  word-wrap: break-word;
  text-align: center;
`;

export const NotificationDate = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #b7bdcb;
`;

export const NotificationDescription = styled.p`
  color: #e9ecf5;
  font-size: 16px;
  font-family: "Custora", serif;
  font-weight: 400;
  line-height: 150%;
  word-wrap: break-word;
  margin: 0;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  color: #5E84ED;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;
  padding: 7.5px 0px;
`;

export const ActionButton = styled.button`
  color: #5E84ED;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;
  cursor: pointer;
  background: none;
  border: none;
`;

export const NotNowButton = styled.button`
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: #b7bdcb;
  width: 100%;
  height: 45px;
  border-radius: 12px;
  background: none;
  border: 0;
`;

export const SuggestionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: auto;
`;

export const SuggestionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #e9ecf5;
  margin: 0;
`;

export const SuggestionDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: #b7bdcb;
  margin: 0;
`;

export const SuggestionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SuggestionItem = styled.li`
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 15px;
  color: #e9ecf5;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 12px;
  background: #23252a;
  border: 1px solid #2b2d33;
  cursor: pointer;
`;

export const SuggestionNote = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #b7bdcb;
  text-align: center;
  margin: 0;
  margin-top: 29px;
  margin-bottom: 17px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  height: 52px;
  gap: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 9999px;
  background: #23252a;
  border-width: 1px;
  border-color: #2b2d33;
  margin-bottom: 59px;
`;

export const PlusIcon = styled.img`
  width: 28px;
  height: 28px;
`;

export const MicIcon = styled.img`
  width: 17px;
  height: 22px;
`;

export const SendIcon = styled.img`
  width: 28px;
  height: 28px;
`;

export const Input = styled.input`
  flex-grow: 1;
  border: none;
  outline: none;
  background: none;
  color: #e9ecf5;
  font-family: 'Inter', sans-serif;
  font-size: 15px;

  &::placeholder {
    color: #b7bdcb;
  }
`;

export const MiddleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

export const MiddleSectionText = styled.span`
  color: #E9ECF5;
  font-size: 24px;
  font-family: "Custora", serif;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;

export const MiddleSectionIcon = styled.img`
`;

export const BottomSectionDescription = styled.span`
  text-align: center;
  color: #B7BDCB;
  font-size: 15px;
  font-family: Inter;
  font-weight: 400;
  line-height: 22.50px;
  word-wrap: break-word;
`;